<p class="govuk-heading-s" [ngClass]="{active: active}">
  {{content}}
  <a href="https://www.adviceaid.uk/" target="_blank" title="Find out more about AdviceAid">Find out more</a>.
</p>


